import { Component, OnInit } from '@angular/core';
import * as $AB from 'jquery';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
   $(".header-title p").text('Billing & Payments');
  }

}
